import { BiReportsTracking } from "@/lib/tracking/biReports";
import { AddIcon } from "@/assets/icons";
import { Button } from "@altimateai/lego";
import InstrumentationDialog from "./InstrumentationDialog";

interface AddInstrumentationButtonProps {
  instrumentationSnippet?: string | null;
  dashboardName?: string;
  dashboardRk?: string;
}

const AddInstrumentationButton = ({
  instrumentationSnippet,
  dashboardRk,
  dashboardName,
}: AddInstrumentationButtonProps) => {
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (dashboardRk) BiReportsTracking.instrumentationAdded(dashboardRk);
  };

  return (
    <InstrumentationDialog
      dashboardRk={dashboardRk}
      instrumentationSnippet={instrumentationSnippet}
      dashboardName={dashboardName}
    >
      <Button variant="secondary" onClick={handleClick}>
        <AddIcon className="h-4 w-4 mr-2" />
        Track Costs
      </Button>
    </InstrumentationDialog>
  );
};

export default AddInstrumentationButton;
